document.addEventListener("DOMContentLoaded", function () {
  var menuItems = document.querySelectorAll("header-menu>details");
  menuItems.forEach(function (item) {
    item.addEventListener("mouseover", function () {
      item.setAttribute("open", true);
    });
    item.addEventListener("mouseout", function () {
      item.removeAttribute("open");
    });
  });
});
